import { DonationType } from "./donation-options";

export const donationsTabs: Array<{ id: DonationType; title: string }> = [
  { id: "TREES", title: "Trees only" },
  { id: "BOTH", title: "Trees & carbon avoidance" },
  { id: "CUSTOM", title: "Custom" },
];
